import type { FaireProductEntity } from "../../entity_types/product";

export const p_4shesxn86n: FaireProductEntity = {
  token: "p_4shesxn86n",
  type: "product",
  name: "TIE-FRONT BUTTOND DOWN MINI DRESS - 7200D",
  brandToken: "b_8tg8mxotwp",
  brandName: "PINCH",
  imageUrl:
    "https://cdn.faire.com/fastly/1d8711b6865b84526a7dd553792602850fd01625beacd790e26c4ff3638b7406.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e97e7d6ae0d00c284e32a5083251cf3db5b63eb877d15e1419efc9c0068e3f8.jpeg",
    "https://cdn.faire.com/fastly/25c5ddd21504f5e65e13706ce2c2b073d93f535a65d103d096525a642c0e2cda.jpeg",
    "https://cdn.faire.com/fastly/88a158ab8f907b6ac634dd6155cdf5cd79fee50910e0f4017765406b7615ce6c.jpeg",
    "https://cdn.faire.com/fastly/64304955f9a6f316e06df8439134ee2d1a0899868e792791e0974a6f6537086b.jpeg",
    "https://cdn.faire.com/fastly/0f563b78964b4ffaea75815ecec621147e2cadc4afa81c76d50f917b4b0e1b87.jpeg",
    "https://cdn.faire.com/fastly/422368874f7629b98bc70f5f57f901f03dacdaa7a65c704568ca645c49d8830d.jpeg",
    "https://cdn.faire.com/fastly/4aff991349a34284ea7697aa5de32d0ecba9ae5771c8104ce732d529a8bec808.jpeg",
    "https://cdn.faire.com/fastly/4a88bd1cbfbf94e9fd23868fa49d06f0408f3d0da88ec311fcff11bad7cf07be.jpeg",
    "https://cdn.faire.com/fastly/9d4254c17a9a5d9e7d09ba8bcf7223fc2e568b69fd3062684a03381e864b5f82.jpeg",
  ],
  priceDollars: 201,
  description:
    "CLASSIC COLLAR\nBUTTON DOWN\nSHORT SLEEVE\nBUTTON AT CUFF\nTIE-FRONT \nMINI LENGTH\n\nMODEL WEARS A SIZE SMALL",
  tags: [],
  msrpDollars: 402,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:52.427Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
